import { useFieldArray } from 'vee-validate';
import Dropzone from '../../ui/Dropzone.vue';
import { useOnDrop } from '../../../hooks/useOnDrop';


export default {
  __name: 'UploadedFileField',
  setup(__props, { expose }) {
  expose();

const { fields, push, remove } = useFieldArray('uploadedFile');

const { onDrop, onSelectFile } = useOnDrop(push, fields);

const __returned__ = { fields, push, remove, onDrop, onSelectFile, get useFieldArray() { return useFieldArray }, Dropzone, get useOnDrop() { return useOnDrop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}